import script from "./BalanceDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./BalanceDialog.vue?vue&type=script&lang=ts&setup=true"

import "./BalanceDialog.vue?vue&type=style&index=0&id=09266498&lang=scss"

const __exports__ = script;

export default __exports__